import _ from 'lodash';
import BPromise from 'bluebird';
import { calculateCartPrice } from 'alvarcarto-price-util';
import * as actions from '../action-types';
import * as api from '../util/api';
import { stringEqualsIgnoreWhitespace } from '../util';

export const setLocation = (location) => {
  const action = {
    type: actions.SET_LOCATION,
    payload: location,
  };

  return action;
};

export const setMapView = (view) => ({
  type: actions.SET_MAP_VIEW,
  payload: view,
  meta: {
    analytics: [
      {
        type: 'designViewContent',
        meta: { debounce: 1000, minTimeOnPage: 3000 },
      },
      {
        type: 'designSetMapView',
        // payload set later
        meta: { debounce: 1000, minTimeOnPage: 3000 },
      },
    ],
  },
});

export const setMapLabels = (labels) => {
  const action = {
    type: actions.SET_MAP_LABELS,
    payload: labels,
    meta: { analytics: [] },
  };

  return action;
};

export const setMapStyle = (style) => ({
  type: actions.SET_MAP_STYLE,
  payload: style,
});

export const setMapResolution = (value) => ({
  type: actions.SET_MAP_RESOLUTION,
  payload: value,
});

export const setDeviceType = (value) => ({
  type: actions.SET_DEVICE_TYPE,
  payload: value,
});

export const setPosterStyle = (style) => ({
  type: actions.SET_POSTER_STYLE,
  payload: style,
});

export const setPosterLayout = (layout) => {
  const action = {
    type: actions.SET_POSTER_LAYOUT,
    payload: layout,
    meta: { analytics: [] },
  };

  return action;
};

export const addCartItem = () => ({
  type: actions.ADD_CART_ITEM,
  meta: {
    analytics: {
      type: 'designAddCartItem',
      // payload enrichened in analytics.js
    },
  },
});

export const removeCartItem = (index) => ({
  type: actions.REMOVE_CART_ITEM,
  payload: index,
  meta: {
    analytics: {
      type: 'designRemoveCartItem',
      // payload added later
    },
  },
});

export const editCartItem = (index) => ({
  type: actions.EDIT_CART_ITEM,
  payload: index,
  meta: {
    analytics: {
      type: 'designEditCartItem',
      payload: {
        userActionParameter: index,
      },
    },
  },
});

export const addCartItemQuantity = (payload) => {
  const action = {
    type: actions.ADD_CART_ITEM_QUANTITY,
    payload: payload,
    meta: { analytics: [] },
  };

  if (payload.add < 0) {
    action.meta.analytics.push({
      type: 'designDecreaseCartItemQuantity',
      payload,
      // payload will be changed later
      meta: { debounce: 1000 },
    });
  } else {
    action.meta.analytics.push({
      type: 'designIncreaseCartItemQuantity',
      payload,
      // payload will be changed later
      meta: { debounce: 1000 },
    });
  }

  return action;
};

export const setPromotion = (payload) => {
  const action = {
    type: actions.SET_PROMOTION,
    payload: payload,
  };

  if (_.get(payload, 'promotionCode')) {
    action.meta = {
      analytics: {
        type: 'designAddPromotion',
        payload: {
          userActionParameter: payload.promotionCode,
        },
      },
    };
  }

  return action;
};

export const checkoutFormStateChange = (payload) => {
  const action = {
    type: actions.CHECKOUT_FORM_STATE_CHANGE,
    payload: payload,
    meta: { analytics: [] },
  };

  if (_.get(payload, 'creditCardForm.isValid')) {
    action.meta.analytics.push({
      type: 'designAddPaymentInfo',
      payload: { userActionParameter: 'valid' },
      meta: {
        maxFireTimes: 1,
      },
    });
  }

  if (_.get(payload, 'emailForm.isValid')) {
    action.meta.analytics.push({
      type: 'designAddValidEmail',
      payload: { userActionParameter: 'valid' },
      meta: {
        maxFireTimes: 1,
      },
    });
  }

  if (_.get(payload, 'shippingAddressForm.isValid')) {
    action.meta.analytics.push({
      type: 'designAddValidShippingAddress',
      payload: { userActionParameter: 'valid' },
      meta: {
        maxFireTimes: 1,
      },
    });
  }

  if (_.get(payload, 'billingAddressForm.isValid')) {
    action.meta.analytics.push({
      type: 'designAddValidBillingAddress',
      payload: { userActionParameter: 'valid' },
      meta: {
        maxFireTimes: 1,
      },
    });
  }

  return action;
}



// WEBPACK FOOTER //
// ./src/actions/index.js